import * as React from "react";

import { DocumentServiceFactory } from "@com.mgmtp.a12.kernel/kernel-md-facade";
import {
	FieldFormatterParams,
	ReferenceCell,
	useFieldFormatter
} from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/view/components/table/sub-components/reference-cell";
import { DefaultComponentMap } from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/view/configuration/component-map";
import { useOverviewEngineContext } from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/view/context/overview-engine-context";

import { FORMAT_FIELD } from "../utilities/variables/modulfRuntimeAnnotations";

/**
 * Custom Component, die im Zusammenhang mit dem Generic_Prozess_WF Modell die richtige Darstellung der Prozess-Status auf dem Dashboard ermöglicht.
 * Intern werden die Labels der Status mit einer ID gesuffixt (bspw. In Prüfung[HF1]). Diese ID muss für die Darstellung entfernt werden.
 * Erweitert eine ReferenceCell.
 */
export const CustomFormatReferenceCell: React.ComponentType<ReferenceCell.Props> = function CustomFormatReferenceCell(
	props
) {
	const { columnModel } = props;
	const formatField = useFieldFormatter();
	const documentModel = useOverviewEngineContext(context => context.documentModel);

	const element = React.useMemo(() => {
		const documentModelService = new DocumentServiceFactory().getDocumentModelSearchService(documentModel);
		const modelPath = documentModelService.getPathById(columnModel.elementRef);
		return modelPath ? documentModelService.getByPath(modelPath) : undefined;
	}, [columnModel.elementRef, documentModel]);

	const fieldFormatter = (params: FieldFormatterParams) => {
		if (element?.annotations?.find(e => e.name === FORMAT_FIELD)?.value === "processState") {
			const formattedField = formatField(params);
			return formattedField.replace(/[[a-zA-Z0-9_]+]$/, "");
		}
		return formatField(params);
	};

	return <DefaultComponentMap.ReferenceCell {...props} fieldFormatter={fieldFormatter} />;
};
